// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"6c866af1","340":"7b8d9265","621":"55083e08"}[chunkId] + ".chunk.js";
};